import React from 'react';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { GlobalToolbarsOverlay } from './components/GlobalToolbarsOverlay';
import { GlobalContextProviders } from './components/_globalContextProviders';
import Page_0 from './pages/login.tsx';
import PageLayout_0 from './pages/login.pageLayout.tsx';
import Page_1 from './pages/_index.tsx';
import PageLayout_1 from './pages/_index.pageLayout.tsx';
import Page_2 from './pages/dashboard.tsx';
import PageLayout_2 from './pages/dashboard.pageLayout.tsx';
import Page_3 from './pages/admin.users.tsx';
import PageLayout_3 from './pages/admin.users.pageLayout.tsx';
import Page_19 from './pages/admin.sso.tsx';
import PageLayout_19 from './pages/admin.sso.pageLayout.tsx';
import Page_4 from './pages/session.$sessionId.tsx';
import PageLayout_4 from './pages/session.$sessionId.pageLayout.tsx';
import Page_5 from './pages/join.$inviteCode.tsx';
import PageLayout_5 from './pages/join.$inviteCode.pageLayout.tsx';
import Page_6 from './pages/workflows.tsx';
import PageLayout_6 from './pages/workflows.pageLayout.tsx';
import Page_7 from './pages/terms-of-service.tsx';
import Page_8 from './pages/privacy-policy.tsx';
import Page_9 from './pages/taskingbot.tsx';
import PageLayout_9 from './pages/taskingbot.pageLayout.tsx';
import Page_10 from './pages/pricing.tsx';
import Page_11 from './pages/ttadmin.tsx';
import PageLayout_11 from './pages/ttadmin.pageLayout.tsx';
import Page_12 from './pages/faq.tsx';
import PageLayout_12 from './pages/faq.pageLayout.tsx';
import Page_13 from './pages/news.tsx';
import PageLayout_13 from './pages/news.pageLayout.tsx';
import Page_14 from './pages/taskingbot.board.tsx';
import PageLayout_14 from './pages/taskingbot.board.pageLayout.tsx';
import Page_15 from './pages/timekeeper.tsx';
import PageLayout_15 from './pages/timekeeper.pageLayout.tsx';
import Page_16 from './pages/taskingbot.tasksuite.tsx';
import PageLayout_16 from './pages/taskingbot.tasksuite.pageLayout.tsx';
import Page_17 from './pages/repoforge.tsx';
import PageLayout_17 from './pages/repoforge.pageLayout.tsx';
import Page_18 from './pages/taskingbot.task.$taskId.tsx';
import Page_19 from './pages/taskingbot.roadmap.tsx';
import PageLayout_19 from './pages/taskingbot.roadmap.pageLayout.tsx';
import Page_20 from './pages/compare.tsx';
import PageLayout_20 from './pages/compare.pageLayout.tsx';
import Page_21 from './pages/skills.tsx';
import PageLayout_21 from './pages/skills.pageLayout.tsx';
import Page_22 from './pages/tsp-apply.tsx';
import PageLayout_22 from './pages/tsp-apply.pageLayout.tsx';
import Page_23 from './pages/music-videos.tsx';
import PageLayout_23 from './pages/music-videos.pageLayout.tsx';
import Page_24 from './pages/video-anime.tsx';
import PageLayout_24 from './pages/video-anime.pageLayout.tsx';
import Page_25 from './pages/video-cartoon.tsx';
import PageLayout_25 from './pages/video-cartoon.pageLayout.tsx';
import Page_26 from './pages/video-cinematic.tsx';
import PageLayout_26 from './pages/video-cinematic.pageLayout.tsx';
import Page_27 from './pages/video-promo.tsx';
import PageLayout_27 from './pages/video-promo.pageLayout.tsx';
import Page_28 from './pages/video-commercial.tsx';
import PageLayout_28 from './pages/video-commercial.pageLayout.tsx';
import Page_29 from './pages/security.tsx';
import Page_31 from './pages/policies.tsx';
import Page_30 from './pages/docs.tsx';
import Page_32 from './pages/s.$token.tsx';
import Page_33 from './pages/shared.$token.tsx';
import Page_34 from './pages/portal.tsx';
import Page_35 from './pages/taskingbot.agents.tsx';
import PageLayout_35 from './pages/taskingbot.agents.pageLayout.tsx';
import Page_36 from './pages/quantum.tsx';
import PageLayout_36 from './pages/quantum.pageLayout.tsx';
import PageLayout_34 from './pages/portal.pageLayout.tsx';
import Page_37 from './pages/taskingbot.book-cover-editor.tsx';
import PageLayout_37 from './pages/taskingbot.book-cover-editor.pageLayout.tsx';

if (!window.requestIdleCallback) {
  window.requestIdleCallback = (cb: IdleRequestCallback) => {
    return window.setTimeout(() => {
      cb({
        didTimeout: false,
        timeRemaining: () => 0,
      } as IdleDeadline);
    }, 1);
  };
}

import './global.css';

const fileNameToRoute = new Map([
  ['./pages/login.tsx', '/login'],
  ['./pages/_index.tsx', '/'],
  ['./pages/dashboard.tsx', '/dashboard'],
  ['./pages/admin.users.tsx', '/admin/users'],
  ['./pages/admin.sso.tsx', '/admin/sso'],
  ['./pages/session.$sessionId.tsx', '/session/:sessionId'],
  ['./pages/join.$inviteCode.tsx', '/join/:inviteCode'],
  ['./pages/workflows.tsx', '/workflows'],
  ['./pages/taskingbot.tsx', '/taskingbot'],
  ['./pages/taskingbot.board.tsx', '/taskingbot/board'],
  ['./pages/taskingbot.agents.tsx', '/taskingbot/agents'],
  ['./pages/taskingbot.tasksuite.tsx', '/taskingbot/tasksuite'],
  ['./pages/taskingbot.roadmap.tsx', '/taskingbot/roadmap'],
  ['./pages/taskingbot.task.$taskId.tsx', '/taskingbot/task/:taskId'],
  ['./pages/taskingbot.book-cover-editor.tsx', '/taskingbot/book-cover-editor'],
  ['./pages/terms-of-service.tsx', '/terms-of-service'],
  ['./pages/privacy-policy.tsx', '/privacy-policy'],
  ['./pages/pricing.tsx', '/pricing'],
  ['./pages/ttadmin.tsx', '/ttadmin'],
  ['./pages/faq.tsx', '/faq'],
  ['./pages/news.tsx', '/news'],
  ['./pages/timekeeper.tsx', '/timekeeper'],
  ['./pages/repoforge.tsx', '/repoforge'],
  ['./pages/compare.tsx', '/compare'],
  ['./pages/skills.tsx', '/skills'],
  ['./pages/tsp-apply.tsx', '/tsp-apply'],
  ['./pages/music-videos.tsx', '/music-videos'],
  ['./pages/video-anime.tsx', '/video-anime'],
  ['./pages/video-cartoon.tsx', '/video-cartoon'],
  ['./pages/video-cinematic.tsx', '/video-cinematic'],
  ['./pages/video-promo.tsx', '/video-promo'],
  ['./pages/video-commercial.tsx', '/video-commercial'],
  ['./pages/security.tsx', '/security'],
  ['./pages/docs.tsx', '/docs'],
  ['./pages/policies.tsx', '/policies'],
  ['./pages/s.$token.tsx', '/s/:token'],
  ['./pages/shared.$token.tsx', '/shared/:token'],
  ['./pages/portal.tsx', '/portal'],
  ['./pages/quantum.tsx', '/quantum'],
]);
const fileNameToComponent = new Map([
  ['./pages/login.tsx', Page_0],
  ['./pages/_index.tsx', Page_1],
  ['./pages/dashboard.tsx', Page_2],
  ['./pages/admin.users.tsx', Page_3],
  ['./pages/admin.sso.tsx', Page_19],
  ['./pages/session.$sessionId.tsx', Page_4],
  ['./pages/join.$inviteCode.tsx', Page_5],
  ['./pages/workflows.tsx', Page_6],
  ['./pages/taskingbot.tsx', Page_9],
  ['./pages/taskingbot.board.tsx', Page_14],
  ['./pages/taskingbot.agents.tsx', Page_35],
  ['./pages/taskingbot.tasksuite.tsx', Page_16],
  ['./pages/taskingbot.roadmap.tsx', Page_19],
  ['./pages/taskingbot.task.$taskId.tsx', Page_18],
  ['./pages/terms-of-service.tsx', Page_7],
  ['./pages/privacy-policy.tsx', Page_8],
  ['./pages/pricing.tsx', Page_10],
  ['./pages/ttadmin.tsx', Page_11],
  ['./pages/faq.tsx', Page_12],
  ['./pages/news.tsx', Page_13],
  ['./pages/timekeeper.tsx', Page_15],
  ['./pages/repoforge.tsx', Page_17],
  ['./pages/compare.tsx', Page_20],
  ['./pages/skills.tsx', Page_21],
  ['./pages/tsp-apply.tsx', Page_22],
  ['./pages/music-videos.tsx', Page_23],
  ['./pages/video-anime.tsx', Page_24],
  ['./pages/video-cartoon.tsx', Page_25],
  ['./pages/video-cinematic.tsx', Page_26],
  ['./pages/video-promo.tsx', Page_27],
  ['./pages/video-commercial.tsx', Page_28],
  ['./pages/security.tsx', Page_29],
  ['./pages/docs.tsx', Page_30],
  ['./pages/policies.tsx', Page_31],
  ['./pages/s.$token.tsx', Page_32],
  ['./pages/shared.$token.tsx', Page_33],
  ['./pages/portal.tsx', Page_34],
  ['./pages/quantum.tsx', Page_36],
  ['./pages/taskingbot.book-cover-editor.tsx', Page_37],
]);

function makePageRoute(filename: string) {
  const Component = fileNameToComponent.get(filename);
  if (!Component) {
    return <NotFound />;
  }
  return <Component />;
}

function toElement({
  trie,
  fileNameToRoute: routeMap,
  makePageRoute: makePageRouteFn,
}: {
  trie: LayoutTrie;
  fileNameToRoute: Map<string, string>;
  makePageRoute: (filename: string) => React.ReactNode;
}) {
  return [
    ...trie.topLevel.map((file) => (
      <Route key={routeMap.get(file)} path={routeMap.get(file)} element={makePageRouteFn(file)} />
    )),
    ...Array.from(trie.trie.entries()).map(([Component, child], index) => (
      <Route
        key={index}
        element={
          <Component>
            <Outlet />
          </Component>
        }
      >
        {toElement({ trie: child, fileNameToRoute: routeMap, makePageRoute: makePageRouteFn })}
      </Route>
    )),
  ];
}

type LayoutTrieNode = Map<React.ComponentType<{ children: React.ReactNode }>, LayoutTrie>;
type LayoutTrie = { topLevel: string[]; trie: LayoutTrieNode };
function buildLayoutTrie(layouts: {
  [fileName: string]: React.ComponentType<{ children: React.ReactNode }>[] | React.ComponentType<{ children: React.ReactNode }>;
}): LayoutTrie {
  const result: LayoutTrie = { topLevel: [], trie: new Map() };
  Object.entries(layouts).forEach(([fileName, components]) => {
    const componentArray = Array.isArray(components) ? components : [components];
    let cur: LayoutTrie = result;
    for (const component of componentArray) {
      if (!cur.trie.has(component)) {
        cur.trie.set(component, {
          topLevel: [],
          trie: new Map(),
        });
      }
      cur = cur.trie.get(component)!;
    }
    cur.topLevel.push(fileName);
  });
  return result;
}

function NotFound() {
  return (
    <div>
      <h1>Not Found</h1>
      <p>The page you are looking for does not exist.</p>
      <p>
        Go back to the{' '}
        <a href="/" style={{ color: 'blue' }}>
          home page
        </a>
        .
      </p>
    </div>
  );
}

// Hoist trie + route elements outside component to avoid re-creating on every render
// (creating new objects in render body causes React to diff new trees -> re-mount -> state loops -> error #185)
const layoutTrie = buildLayoutTrie({
  './pages/login.tsx': PageLayout_0,
  './pages/_index.tsx': PageLayout_1,
  './pages/dashboard.tsx': PageLayout_2,
  './pages/admin.users.tsx': PageLayout_3,
  './pages/admin.sso.tsx': PageLayout_19,
  './pages/session.$sessionId.tsx': PageLayout_4,
  './pages/join.$inviteCode.tsx': PageLayout_5,
  './pages/workflows.tsx': PageLayout_6,
  './pages/taskingbot.tsx': PageLayout_9,
  './pages/taskingbot.board.tsx': PageLayout_14,
  './pages/taskingbot.agents.tsx': PageLayout_35,
  './pages/taskingbot.tasksuite.tsx': PageLayout_16,
  './pages/taskingbot.roadmap.tsx': PageLayout_19,
  './pages/taskingbot.task.$taskId.tsx': PageLayout_9,
  './pages/terms-of-service.tsx': PageLayout_1,
  './pages/privacy-policy.tsx': PageLayout_1,
  './pages/pricing.tsx': PageLayout_1,
  './pages/ttadmin.tsx': PageLayout_11,
  './pages/faq.tsx': PageLayout_12,
  './pages/news.tsx': PageLayout_13,
  './pages/timekeeper.tsx': PageLayout_15,
  './pages/repoforge.tsx': PageLayout_17,
  './pages/compare.tsx': PageLayout_20,
  './pages/skills.tsx': PageLayout_21,
  './pages/tsp-apply.tsx': PageLayout_22,
  './pages/music-videos.tsx': PageLayout_23,
  './pages/video-anime.tsx': PageLayout_24,
  './pages/video-cartoon.tsx': PageLayout_25,
  './pages/video-cinematic.tsx': PageLayout_26,
  './pages/video-promo.tsx': PageLayout_27,
  './pages/video-commercial.tsx': PageLayout_28,
  './pages/security.tsx': PageLayout_1,
  './pages/docs.tsx': PageLayout_1,
  './pages/policies.tsx': PageLayout_1,
  './pages/s.$token.tsx': PageLayout_1,
  './pages/shared.$token.tsx': PageLayout_0,
  './pages/portal.tsx': PageLayout_34,
  './pages/quantum.tsx': PageLayout_36,
  './pages/taskingbot.book-cover-editor.tsx': PageLayout_37,
});
const routeElements = toElement({ trie: layoutTrie, fileNameToRoute, makePageRoute });

export function App() {
  return (
    <BrowserRouter>
      <GlobalContextProviders>
        <Routes>
          {routeElements}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <GlobalToolbarsOverlay />
      </GlobalContextProviders>
    </BrowserRouter>
  );
}
